"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var react_1 = require("react");
var Button_1 = require("../../atoms/Button/Button");
var Divider_1 = require("../../atoms/Divider/Divider");
var Typography_1 = require("../../atoms/Typography/Typography");
var Pagination_1 = require("../Pagination/Pagination");
var Table_logic_1 = require("./Table.logic");
var Table_static_1 = require("./Table.static");
var TableHeader_1 = __importDefault(require("./TableHeader/TableHeader"));
var TableRow_1 = __importDefault(require("./TableRow/TableRow"));
/**
 * Table molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-table--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/Table Source}
 */
var Table = function (_a) {
    var alternatingColors = _a.alternatingColors, className = _a.className, _b = _a.clickable, clickable = _b === void 0 ? false : _b, _c = _a.columnGap, columnGap = _c === void 0 ? '16px' : _c, columnsTemplate = _a.columnsTemplate, compact = _a.compact, defaultSort = _a.defaultSort, groupBy = _a.groupBy, _d = _a.fixedLayout, fixedLayout = _d === void 0 ? false : _d, maxHeight = _a.maxHeight, mountWithRowKey = _a.mountWithRowKey, noResults = _a.noResults, _e = _a.pageChangeScrollCorrection, pageChangeScrollCorrection = _e === void 0 ? 0 : _e, _f = _a.paginationPosition, paginationPosition = _f === void 0 ? 'both' : _f, primaryAction = _a.primaryAction, rows = _a.rows, rowsPerPage = _a.rowsPerPage, secondaryActions = _a.secondaryActions, stickyHeader = _a.stickyHeader, title = _a.title, _g = _a.width, width = _g === void 0 ? '100%' : _g;
    var _h = (0, Table_logic_1.useTable)({
        columnsTemplate: columnsTemplate,
        groupBy: groupBy,
        mountWithRowKey: mountWithRowKey,
        noResults: noResults,
        pageChangeScrollCorrection: pageChangeScrollCorrection,
        rows: rows,
        rowsPerPage: rowsPerPage,
        sortBy: defaultSort === null || defaultSort === void 0 ? void 0 : defaultSort.sortBy,
        sortOrder: defaultSort === null || defaultSort === void 0 ? void 0 : defaultSort.sortOrder,
    }), classes = _h.classes, containerRef = _h.containerRef, goToFirstPage = _h.goToFirstPage, goToLastPage = _h.goToLastPage, goToNextPage = _h.goToNextPage, goToPreviousPage = _h.goToPreviousPage, headerBuilt = _h.headerBuilt, isOnFirstPage = _h.isOnFirstPage, isOnLastPage = _h.isOnLastPage, itemsOnPageInfo = _h.itemsOnPageInfo, noResultsWidth = _h.noResultsWidth, rowsBuilt = _h.rowsBuilt;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: className, ref: containerRef }, { children: [renderPreContent(), (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.wrapper, style: { width: width, maxHeight: maxHeight } }, { children: [(0, jsx_runtime_1.jsxs)("table", __assign({ className: (0, classnames_1.default)(classes.tableRoot, fixedLayout && classes.fixedLayout) }, { children: [(0, jsx_runtime_1.jsx)(TableHeader_1.default, { sticky: stickyHeader, cells: headerBuilt, columnGap: columnGap }), (0, jsx_runtime_1.jsx)("tbody", __assign({ className: classes.tbody }, { children: renderRows() }))] })), !['top', 'none'].includes(paginationPosition) && (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.footer }, { children: renderPagination() }))] }))] })));
    function renderPreContent() {
        if (!title && (paginationPosition === 'bottom' || paginationPosition === 'none') && !primaryAction) {
            return null;
        }
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.preContent }, { children: [!!title && (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'headline2' }, { children: title })), primaryAction, (0, lodash_1.map)(secondaryActions, renderSecondaryAction), !['bottom', 'none'].includes(paginationPosition) && renderPagination()] })));
    }
    function renderSecondaryAction(_a) {
        var title = _a.title, rest = __rest(_a, ["title"]);
        return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Divider_1.Divider, { className: classes.divider, margin: { right: 12, left: 12 }, vertical: true }), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ title: title, variant: 'text' }, rest))] }, title));
    }
    function renderRows() {
        if (noResults) {
            return ((0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", __assign({ colSpan: noResultsWidth, className: classes.noResult }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, { children: Table_static_1.localText.noResults }) })) }));
        }
        return rowsBuilt.map(function (_a) {
            var cells = _a.cells, onClick = _a.onClick, rowKey = _a.rowKey, state = _a.state;
            return ((0, jsx_runtime_1.jsx)(TableRow_1.default, { alternatingColors: alternatingColors, className: (0, classnames_1.default)(clickable && classes.clickable), cells: cells, columnGap: columnGap, compact: compact, onClick: onClick, state: state }, rowKey));
        });
    }
    function renderPagination() {
        return ((0, jsx_runtime_1.jsx)(Pagination_1.Pagination, { className: classes.pagination, isOnFirstPage: isOnFirstPage, isOnLastPage: isOnLastPage, goToPreviousPage: goToPreviousPage, goToNextPage: goToNextPage, goToFirstPage: goToFirstPage, goToLastPage: goToLastPage, pageInfo: itemsOnPageInfo }));
    }
};
exports.Table = Table;
